import actions from "./actions";
import { LOGOUT } from "../../../data/user/actions";
import moment from 'moment';

const initialState = {
    isLoading: false,
    clockedIn: null,
    employees: [],
    events: [],
    clock: null,
    activities: null,
    warehouses: null,
    recentClocks: null,
    loadedClock: null,
    admin: {
        warehouse_id: null,
        activity_id: null,
        employee_id: null,
        clock_id: null,
        start: moment().startOf('month'),
        end: moment(),
    },
};

// -----------------------------------------------------------------------------
// REDUCER

export default (state = initialState, action) => {
    switch (action.type) {


        case actions.CLOCK_ADMIN_SET_WAREHOUSE:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    warehouse_id: action.warehouse_id,
                }
            };
        case actions.CLOCK_ADMIN_SET_EMPLOYEE:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    employee_id: action.employee_id,
                }
            };
        case actions.CLOCK_ADMIN_SET_ACTIVITY:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    activity_id: action.activity_id,
                }
            };
        case actions.CLOCK_ADMIN_SET_DATE_RANGE:
            return {
                ...state,
                admin: {
                    ...state.admin,
                    start: action.start,
                    end: action.end,
                }
            };
        case actions.CLOCK_GET_SUCCESS:
            return {
                ...state,
                clockedIn: action.clock.clockedIn,
                clock: action.clock.clock,
                activities: action.clock.activities,
                warehouses: action.clock.warehouses,
                recentClocks: action.clock.recentClocks,
                isLoading: false,
            };
        case actions.CLOCK_IN_SUCCESS:
            return {
                ...state,
                clockedIn: action.clock.clockedIn,
                clock: action.clock.clock,
                recentClocks: action.clock.recentClocks,
                isLoading: false,
            };
        case actions.CLOCK_OUT_SUCCESS:
            return {
                ...state,
                clockedIn: action.clock.clockedIn,
                clock: action.clock.clock,
                recentClocks: action.clock.recentClocks,
                isLoading: false,
            };
        case actions.CLOCK_ADMIN_CLOCKS_SUCCESS:
            return {
                ...state,
                adminClocks: action.clocks,
                isLoading: false,
            };

        case actions.CLOCK_LOAD_SUCCESS:
        case actions.CLOCK_SAVE_SUCCESS:
            return {
                ...state,
                loadedClock: action.clock.clock,
                activities: action.clock.activities,
                warehouses: action.clock.warehouses,
                isLoading: false,
            };

        case actions.CLOCK_GET_EMPLOYEES_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actions.CLOCK_GET_EMPLOYEES_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case actions.CLOCK_GET_EMPLOYEES_SUCCESS:
            console.log(action);
            return {
                ...state,
                isLoading: false,
                employees: action.employees
            };

        case actions.CLOCK_GET_EVENTS_FAILURE:
            return {
                ...state,
                isLoading: false
            };

        case actions.CLOCK_GET_EVENTS_REQUEST:
            return {
                ...state,
                isLoading: true
            };

        case actions.CLOCK_GET_EVENTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                events: action.events
            };

        case actions.CLOCK_SAVE_EVENTS_FAILURE:
            return {
                ...state,
                isLoading: false
            };

        case actions.CLOCK_SAVE_EVENTS_REQUEST:
            return {
                ...state,
                isLoading: true
            };

        case actions.CLOCK_SAVE_EVENTS_SUCCESS:

            return {
                ...state,
                isLoading: false,
            };


        case actions.CLOCK_ADMIN_CLOCKS_REQUEST:
        case actions.CLOCK_GET_REQUEST:
        case actions.CLOCK_LOAD_REQUEST:
        case actions.CLOCK_SAVE_REQUEST:
        case actions.CLOCK_OUT_REQUEST:
        case actions.CLOCK_IN_REQUEST:
        case actions.CLOCK_ADMIN_NEW_CLOCK_REQUEST:

            return {
                ...state,
                isLoading: true,
            };

        case actions.CLOCK_GET_FAILURE:
        case actions.CLOCK_LOAD_FAILURE:
        case actions.CLOCK_SAVE_FAILURE:
        case actions.CLOCK_IN_FAILURE:
        case actions.CLOCK_OUT_FAILURE:
        case actions.CLOCK_ADMIN_CLOCKS_FAILURE:
        case actions.CLOCK_ADMIN_NEW_CLOCK_FAILURE:
        case actions.CLOCK_ADMIN_NEW_CLOCK_SUCCESS:
            return {
                ...state,
                isLoading: false,
            };
        case LOGOUT:
            return initialState;
        default:
            return state
    }
}

// -----------------------------------------------------------------------------
// PRIVATE SELECTORS

export function isClockedIn(store) {
    return store.clock.clockedIn
}

export function getClock(store) {
    return store.clock.clock
}

export function getEmployees(store) {
    return store.clock.employees;
}

export function getEvents(store) {
    return store.clock.events;
}

export function getAdminClocks(store) {
    return store.clock.adminClocks
}

export function getLoadedClock(store) {
    return store.clock.loadedClock
}

export function getActivities(store) {
    return store.clock.activities
}

export function getWarehouses(store) {
    return store.clock.warehouses
}

export function getRecentClocks(store) {
    return store.clock.recentClocks
}

export function isLoading(store) {
    return store.clock.isLoading
}

export function getAdminSetWarehouse(store){
    return store.clock.admin.warehouse_id;
}

export function getAdminSetActivity(store){
    return store.clock.admin.activity_id;
}

export function getAdminSetEmployee(store){
    return store.clock.admin.employee_id;
}

export function getAdminSetDateRange(store){
    return {
        start: store.clock.admin.start,
        end: store.clock.admin.end,
    };
}



// WEBPACK FOOTER //
// ./src/scenes/Clock/reducer/index.js